// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import Icon, { ICON_SIZE_16 } from '../Icon';
const TabIcon = _ref => {
  let {
    icon,
    baseClassName
  } = _ref;
  return Icon.create(icon, {
    size: ICON_SIZE_16,
    className: `${baseClassName}__tab-icon`
  });
};
export default TabIcon;